export class File {
  name: string;
  url: string;
}

export class FileGroup {
  title: string;
  description: string;
  fileGroupId: string;
  files: File[];
  created: Date;

  static fromApiModel(model: any): FileGroup {
    const fileGroup = new FileGroup();
    for (const key in model) {
      if (Object.prototype.hasOwnProperty.call(model, key)) {
        fileGroup[toCamelCase(key)] = model[key];
      }
    }
    fileGroup.created = model.created; // TODO: if something is messed up this might be why
    return fileGroup;
  }
}

export function toCamelCase(s: string): string {
  return s.replace(/(_\w)/g, (m) => {
    return m[1].toUpperCase();
  });
}
